import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProductResponse } from '../models/products.types';
import { ApiConfigService } from '../../../core/services/api-config.service';
import { Period } from '../../../core/constants/periods';

export abstract class ProductsDataSource {
  abstract getProducts(projectId: string, solutionId: string, period: Period): Observable<ProductResponse[]>;
}

export class ApiProductsDataSource implements ProductsDataSource {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfigService);

  getProducts(projectId: string, solutionId: string, period: Period): Observable<ProductResponse[]> {
    return this.http.get<ProductResponse[]>(
      this.apiConfig.endpoint(`project/${projectId}/solutions/${solutionId}/products`),
      { params: { period: period } },
    );
  }
}
